import React, { Fragment, useState } from "react";
import { appPath, APP_PATHS } from '../../utils/appPaths.js';
import { Link } from "react-router-dom";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Image } from "../../AbstractElements";
import logoWhite from "../../assets/images/logo/logo-white.png";
import AuthService from "../../Services/auth/AuthService";
import TailChase from "../../Components/Loaders/TailChase";
import { toUserMessage } from "../../utils/apiErrorMessage";

const ForgetPwd = ({ logoClassMain }) => {
  const [emailValue, setEmailValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handeForgetPwd = async (e) => {
    e.preventDefault();
    const email = emailValue.trim();
    if (!email) {
      toast.error("Please enter your email address.");
      return;
    }

    setLoading(true);
    try {
      const { success, message } = await AuthService.forgotPassword(email);
      if (success) {
        setSent(true);
        toast.success(
          toUserMessage(
            message,
            "If that email exists, a password reset link has been sent."
          )
        );
      } else {
        toast.error(
          toUserMessage(message, "Failed to send password reset email.")
        );
      }
    } catch (error) {
      toast.error(
        toUserMessage(error, "Failed to send password reset email.")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <section>
        <Container className="p-0 login-page" fluid={true}>
          <Row className="m-0">
            <Col className="p-0">
              <div className="login-card login-card--mono">
                <div>
                  <div>
                    <Link
                      className={`logo ${logoClassMain ? logoClassMain : ""}`}
                      to={APP_PATHS.login}
                    >
                      <Image
                        attrImage={{
                          className: "img-fluid for-light login-logo-white",
                          src: logoWhite,
                          alt: "reddiamond.",
                        }}
                      />
                    </Link>
                  </div>
                  <div className="login-main">
                    <Form
                      className="theme-form login-form"
                      onSubmit={handeForgetPwd}
                    >
                      <h4 className="mb-3">Reset Your Password</h4>
                      {sent ? (
                        <p className="mb-3">
                          If an account exists for that email, we sent a reset
                          link. Check your inbox and spam folder.
                        </p>
                      ) : (
                        <FormGroup className="position-relative">
                          <Label className="col-form-label m-0">
                            Enter Your Email
                          </Label>
                          <Input
                            className="form-control"
                            type="email"
                            autoComplete="email"
                            placeholder="Enter your Email"
                            value={emailValue}
                            onChange={(e) => setEmailValue(e.target.value)}
                            required
                          />
                        </FormGroup>
                      )}
                      {!sent && (
                        <FormGroup>
                          <button
                            type="submit"
                            className="btn btn-login-mono d-block w-100"
                            disabled={loading}
                          >
                            {loading ? <TailChase /> : "Send"}
                          </button>
                        </FormGroup>
                      )}

                      <p className="text-start mb-0">
                        Already have a password?
                        <Link to={appPath('/login')} className="ms-2 link">
                          Sign in
                        </Link>
                      </p>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <ToastContainer position="top-right" autoClose={4500} newestOnTop />
    </Fragment>
  );
};

export default ForgetPwd;
